import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import ModalBasic from "../../../components/ModalBasic/ModalBasic";
import { AddEditCursos } from "../../../components/GestionAcademica/TableCursos/AddEditCursos";
import { Navigate, useNavigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader, Dropdown } from "semantic-ui-react";
import { TableCursos } from "../../../components/GestionAcademica/TableCursos/TableCursos";
import Swal from "sweetalert2";

function Cursos() {
  const { auth } = useAuth();
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaCursos />;
}

function LogicaCursos() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cursos, setCursos] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [loadingPeriodos, setLoadingPeriodos] = useState(true);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [selectedPeriodoId, setSelectedPeriodoId] = useState(null);
  const [periodos, setPeriodos] = useState(null);
  const openCloseModal = () => setShowModal((prev) => !prev);

  async function getPeriodos() {
    try {
      setLoadingPeriodos(true);
      const response = await axios.get(`${BASE_API}/api/periodo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const periodos = response.data;
      setLoadingPeriodos(false);
      setPeriodos(periodos);
      return periodos;
    } catch (error) {
      setLoadingPeriodos(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getPeriodos();
    // eslint-disable-next-line
  }, [refetch]);

  const getPeriodoMasReciente = (periodos) => {
    if (!periodos || periodos.length === 0) return null;
    const periodoMasReciente = periodos.reduce((prev, current) => {
      const prevInicio = new Date(prev.fecha_inicio);
      const prevFin = new Date(prev.fecha_fin);
      const currentInicio = new Date(current.fecha_inicio);
      const currentFin = new Date(current.fecha_fin);
      return currentInicio > prevInicio ||
        (currentInicio.getTime() === prevInicio.getTime() &&
          currentFin > prevFin)
        ? current
        : prev;
    });
    return periodoMasReciente;
  };

  useEffect(() => {
    if (periodos) {
      // Solo establecer el periodo inicial si no hay un periodo seleccionado
      if (!selectedPeriodo) {
        const periodoInicial = getPeriodoMasReciente(periodos);
        setSelectedPeriodo(periodoInicial);
        setSelectedPeriodoId(periodoInicial?.id_periodo);
      } else {
        // Si ya hay un periodo seleccionado, simplemente recarga los cursos
        getCursosApi(selectedPeriodoId);
      }
    }
    // eslint-disable-next-line
  }, [periodos]);

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  };

  function formatoDropdownPeriodo(informacionCicloEscolar) {
    if (!informacionCicloEscolar || informacionCicloEscolar.length === 0) {
      return [];
    }
    return informacionCicloEscolar.map((item) => ({
      key: item.id_periodo,
      text: `${formatPeriodo(item.fecha_inicio)} - ${formatPeriodo(
        item.fecha_fin
      )}`,
      value: item.id_periodo,
    }));
  }

  const handlePeriodoChange = (event, data) => {
    const periodoSeleccionado = periodos.find(
      (periodo) => periodo.id_periodo === data.value
    );
    setSelectedPeriodo(periodoSeleccionado);
    setSelectedPeriodoId(data.value);
    getCursosApi(data.value);
  };

  async function getCursosApi(periodoId) {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/curso/?periodo=${periodoId}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const cursosData = response.data;
      setLoading(false);
      setCursos(cursosData);
      return cursosData;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (selectedPeriodoId) {
      getCursosApi(selectedPeriodoId);
    }
    // eslint-disable-next-line
  }, [refetch, selectedPeriodoId]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const createCurso = () => {
    setTitleModal("Nuevos Cursos");
    setContentModal(
      <AddEditCursos onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const verCurso = async (data) => {
    navigate("/cursos/AlumnosCurso", { state: { datosCurso: data } });
  };

  const updateCurso = async (data) => {
    setTitleModal("Actualizar datos curso");
    setContentModal(
      <AddEditCursos
        onClose={openCloseModal}
        onRefetch={onRefetch}
        curso={data}
      />
    );
    openCloseModal();
  };

  const ondelete = async (dataCurso) => {
    const confirmMessage = `<div>¿Seguro de eliminar el curso ${dataCurso.materia_data.nombre_materia}?</div>
    <div style="color: red;">Nota: Si tiene registros de alumnos y/o calificaciones no será eliminado aunque confirme esta acción</div>`;

    const result = await Swal.fire({
      // title: '¿Estás seguro?',
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/curso/${dataCurso.id}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {}
    }
  };

  return (
    <div>
      <h1 className="tituloin">Cursos</h1>

      <HeaderPage btnTitulo="Crear nuevo(s) curso(s)" btnClick={createCurso} />
      {loadingPeriodos ? (
        <Loader active inline="centered">
          Cargando periodos....
        </Loader>
      ) : (
        <div
          style={{
            paddingTop: "20px",
            maxWidth: "70%",
            paddingBottom: "24px",
          }}
        >
          <div>
            <h4 style={{ paddingBottom: "12px" }}>Filtrar por periodo</h4>
          </div>
          <Dropdown
            placeholder="Seleccionar Periodo"
            fluid
            selection
            options={formatoDropdownPeriodo(periodos)}
            onChange={handlePeriodoChange}
            value={selectedPeriodoId}
          />
        </div>
      )}
      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableCursos
          cursos={cursos}
          updateCurso={updateCurso}
          deleteCurso={ondelete}
          verCurso={verCurso}
        />
      )}
      <ModalBasic
        show={showModal}
        title={titleModal}
        children={contentModal}
        close={openCloseModal}
      />
    </div>
  );
}

export default Cursos;
